import {useEffect} from 'react';
import {FallbackRender} from '@sentry/react';
import {getErrorMessage} from 'utils';
import {useARStore} from 'stores';
import {Button} from 'components';
import {xrStore} from 'lib';

const ErrorFallback = ({error, componentStack, eventId}: Parameters<FallbackRender>[0]) => {
  const errorMessage = getErrorMessage(error);

  useEffect(() => {
    xrStore.getState().session?.end();
    useARStore.getState().reset();
  }, []);

  return (
    <section className="flex flex-col justify-center items-center w-screen min-h-screen p-3 pb-48 select-none">
      <p className="text-center text-red-500 text-6xl md:text-7xl font-bold mb-3">Oops!</p>
      <p className="text-center text-slate-800 text-xl md:text-2xl font-semibold mb-3">An error occurred</p>
      <p className="text-center text-slate-700 text-lg mb-6">Sorry, you can refresh the page to try again.</p>
      <Button text="Refresh Page" variant="secondary" rounded onClick={() => location.reload()} />
      {import.meta.env.DEV && !!errorMessage && (
        <>
          <p className="text-center text-indigo-500 font-medium mt-6">Sentry event ID: {eventId}</p>
          <p className="text-center text-red-500 font-medium text-lg ">{errorMessage}</p>
          <code className="w-full -mb-40 overflow-scroll bg-black text-white rounded-md p-3 mt-6 whitespace-pre-line">{componentStack}</code>
        </>
      )}
    </section>
  );
};

export default ErrorFallback;
